module.exports = function(data) {
  let topicList = ''
  data.forEach(item => {
    topicList += `
      <li topicId="${item.topic_id}" awardId="${item.award.award_id}">
        ${item.award.award_id ? '<span class="reward">限时有奖</span>' : ''}
        <h2 class="title">#${item.topic_name}</h2>
        <p class="desc">${item.remark}</p>
        ${
          item.topic_type === 'writing'
            ? +item.prewriting || +item.wrote_count
              ? `
            <div class="more">
              <span>${item.story_count}个笔记</span>
              <span>完成进度${item.wrote_count}/${item.award.story_num}</span>
              ${
                item.award.award_id
                  ? `<span class="${
                      +item.award.can_receive || +item.award.has_receive
                        ? 'active'
                        : ''
                    } showReward" ${
                      +item.award.has_receive ? 'hasReceive=true' : ''
                    }">查看奖励</span>`
                  : ''
              }
            </div>
          `
              : `
            <div class="join">
              <span class="btn">参加</span>
              <p class="number">${item.prewriting_count}人参加计划</p>
            </div>
          `
            : `<div class="more"><span>${item.story_count}个笔记</span></div>`
        }
      </li>
    `
  })
  return topicList
}



// WEBPACK FOOTER //
// ./src/pages/ask/askBranch/render/topicList.js